import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventYellowCard extends DomainEvent<MatchEvent> {}
